// extracted by mini-css-extract-plugin
module.exports = {"title":"_1WPFzAQ4qw_-tzsBfwThNM appSubtitle"};